import { Component, Host, h, Prop } from '@stencil/core';
import { format } from '../../utils/utils';

@Component({
  tag: 'banner-resource-hero',
  styleUrl: 'banner-resource-hero.css',
  shadow: true,
})
export class BannerResourceHero {
  /**
   * The first name
   */
  @Prop() first: string;

  /**
   * The middle name
   */
  @Prop() middle: string;

  /**
   * The last name
   */
  @Prop() last: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  private getText(): string {
    return format(this.first, this.middle, this.last);
  }

  render() {
    return (
      <Host>
        <div class={`${this.backgroundColor} p-16px flex justify-center`}>
          <h2 class={`${this.textColor} text-5 font-thin`}>Hello, Banner Resource Hero! I'm {this.getText()}</h2>
        </div>
        <slot></slot>
      </Host>
    );
  }
}
